/**
 * Strips markdown and HTML tags from text.
 * Removes HTML tags, markdown formatting (bold, italic, code, links, images),
 * and decodes common HTML entities.
 * 
 * @param {string} text - The text to clean
 * @returns {string} - The cleaned text without markdown and HTML
 */
export const stripMarkdownAndHtml = (text) => {
  if (!text || typeof text !== 'string') return text;

  let cleaned = text;

  // Remove HTML tags (including nested tags)
  cleaned = cleaned.replace(/<[^>]*>/g, '');

  // Remove markdown bold syntax (**text** or __text__)
  cleaned = cleaned.replace(/\*\*(.*?)\*\*/g, '$1');
  cleaned = cleaned.replace(/__(.*?)__/g, '$1');

  // Remove markdown italic syntax (*text* or _text_)
  cleaned = cleaned.replace(/\*(.*?)\*/g, '$1');
  cleaned = cleaned.replace(/_(.*?)_/g, '$1');

  // Remove markdown code syntax (`code`)
  cleaned = cleaned.replace(/`([^`]*)`/g, '$1');

  // Remove markdown links [text](url)
  cleaned = cleaned.replace(/\[([^\]]*)\]\([^\)]*\)/g, '$1');

  // Remove markdown images ![alt](url)
  cleaned = cleaned.replace(/!\[([^\]]*)\]\([^\)]*\)/g, '$1');

  // Decode common HTML entities
  cleaned = cleaned.replace(/&nbsp;/g, ' ');
  cleaned = cleaned.replace(/&amp;/g, '&');
  cleaned = cleaned.replace(/&lt;/g, '<');
  cleaned = cleaned.replace(/&gt;/g, '>');
  cleaned = cleaned.replace(/&quot;/g, '"');
  cleaned = cleaned.replace(/&#39;/g, "'");

  // Replace newlines and line breaks with spaces
  cleaned = cleaned.replace(/\n\n/g, ' ');
  cleaned = cleaned.replace(/\n/g, ' ');
  cleaned = cleaned.replace(/\r\n/g, ' ');
  cleaned = cleaned.replace(/\r/g, ' ');

  // Clean up extra whitespace
  cleaned = cleaned.replace(/\s+/g, ' ').trim();

  return cleaned;
};

